/* eslint-disable no-console */

import * as Sentry from '@sentry/angular';
import { environment } from '@environments/environment';

const SENTRY_ENABLED = !!environment.sentry_dsn;

export class Logger {
  constructor(private name: string) {}

  debug(...data: any[]) {
    if (environment.debug) {
      console.debug(`[${this.name}]`, ...data);
    }
  }

  error(message: string, ...optionalParams: unknown[]) {
    console.error(`[${this.name}]`, message, ...optionalParams);
    if (SENTRY_ENABLED) {
      Sentry.captureMessage(message, {
        level: 'error',
        extra: { arguments: optionalParams },
        tags: {
          loggerName: this.name,
        },
      });
    }
  }
}
